(function() {
  'use strict';

  function EmailLogSlotController($uibModal, $translate, EmailLogs, Security, Notify) {
    var ctrl = this;

    ctrl.$onInit = function() {
      ctrl.setup();
    };

    Security.hasPermission('emailTemplates.view')
      .then(function(allowed) {
        ctrl.canViewEmailSent = allowed;
      });

    ctrl.setup = function() {
      if (ctrl.emailLog.doc.related) {
        ctrl.related = {
          id: ctrl.emailLog.doc.related.id,
          type: ctrl.emailLog.doc.related.type
        };

        if (ctrl.related.type === 'event') {
          ctrl.related.route = ['/users/edit/events', ctrl.related.id];
        }
      }
      ctrl.actionButtons = [
        {
          label: ctrl.shownDetails ? 'Hide details' : 'Show details',
          icon: 'icon-history',
          onClick: function() {
            ctrl.shownDetails = !ctrl.shownDetails;
            this.label = ctrl.shownDetails ? 'Hide details' : 'Show details';
          },
          showCondition: Security.hasPermission.bind(this, 'emailTemplates.view'),
          klass: 'text-info'
        }
      ];
      ctrl.secondaryActionButtons = [
        {
          label: $translate.instant('Send again'),
          icon: 'icon-undo',
          onClick: function() {
            ctrl.resend();
          },
          showCondition: Security.hasPermission.bind(this, 'emailTemplates.view'),
          klass: 'text-warning'
        }
      ];

      ctrl.preview = function() {
        $uibModal.open({
          animation: true,
          template: '<email-view data="ctrl.data" on-close="$close()"></email-view>',
          controller: ['data',
            function(data) {
              this.data = data;
            }
          ],
          controllerAs: 'ctrl',
          resolve: {
            data: function() {
              return {
                subject: ctrl.emailLog.doc.subject,
                html: ctrl.emailLog.doc.html,
                email_from: ctrl.emailLog.doc.email_from,
                recipients: ctrl.emailLog.doc.recipients,
                messageId: ctrl.emailLog.doc.messageId,
                state_log: ctrl.emailLog.doc.state_log,
                date: ctrl.emailLog.doc.createdDate
              };
            }
          },
          size: 'lg'
        }).result.catch(function(err) {
          console.log('Dismissed', err);
        });
      };

      ctrl.resend = function() {
        var result = $uibModal.open({
          animation: true,
          templateUrl: 'app/components/email-logs/email-log-resend.html',
          controller: ['emailLog', 'UsersStubService', '$translate',
            function(emailLog, UsersStub, $translate) {
              var innerCtrl = this;
              this.emailLog = emailLog;
              this.data = {};
              this.allowRegenerate = !emailLog.doc.using_preferred_partials;

              if (this.emailLog.doc.recipient_username) {
                UsersStub.find(this.emailLog.doc.recipient_username)
                  .then(function(stub) {
                    innerCtrl.currentEmail = stub.email;
                    innerCtrl.originalEmail = ctrl.emailLog.doc.recipients.length === 1 ?
                      ctrl.emailLog.doc.recipients[0] : null;
                    // eslint-disable-next-line max-len
                    innerCtrl.emailChangedInfo = $translate.instant('Original email has been sent to <strong>{{original}}</strong>. The user\'s primary email has changed to <strong>{{current}}</strong>. Please check it below if you would like to send it to the new email instead.', { original: innerCtrl.originalEmail, current: innerCtrl.currentEmail });
                    // eslint-disable-next-line max-len
                    innerCtrl.sendToLabel = $translate.instant('Send to {{email}}', { email: innerCtrl.currentEmail });
                  })
                  .catch(function(err) {
                    console.log(err);
                    Notify.warning('Could not find profile');
                  });
              }
            }
          ],
          controllerAs: 'ctrl',
          resolve: {
            emailLog: ctrl.emailLog
          },
          size: 'md'
        }).result;

        return result
        .then(function(data) {
          if (!data) {
            Notify.error('No data received');
            return;
          }

          return EmailLogs.resend(ctrl.emailLog.doc.id, data)
            .then(function() {
              Notify.success('Email has been resent');
            })
            .catch(function(err) {
              var errorMsg;
              if (err && err.message) {
                errorMsg = err.message;
              } else {
                errorMsg = err;
              }
              Notify.error(errorMsg);
            });
        })
        .catch(function(err) {
          console.log('Dismissed', err);
        });
      };
    };
  }

  EmailLogSlotController.$inject = [
    '$uibModal',
    '$translate',
    'EmailLogsService',
    'SecurityService',
    'NotifyService'


  ];

  angular.module('component.emailLogs')
    .component('emailLogSlot', {
      templateUrl: 'app/components/email-logs/email-log-slot.html',
      controller: EmailLogSlotController,
      bindings: {
        emailLog: '<',
        options: '<'
      }
    });
})();
